import { login, logout } from './utils';
import './App.css';
import logo from './assets/images/seatlabnft-logo.png';
import logo2x from './assets/images/seatlabnft-logo@2x.png';
import logo3x from './assets/images/seatlabnft-logo@3x.png';
import logoSmall from './assets/images/logo-small.png';
import logoSmall2x from './assets/images/logo-small@2x.png';
import logoSmall3x from './assets/images/logo-small@3x.png';
import { ReactComponent as TwitterLogo } from './assets/svgs/twitter-logo.svg';
import { ReactComponent as DiscordLogo } from './assets/svgs/discord-logo.svg';
import { ReactComponent as MediumLogo } from './assets/svgs/medium.svg';

const getFormattedAccountId = accountId => {
    return {
        small: accountId.length < 13 ? accountId : accountId.slice(0, 11) + "...",
        large: accountId.length < 18 ? accountId : accountId.slice(0, 16) + "...",
    };
};

const App = props => {
    const { accountId, claimableTokens, contract, nearConfig, walletConnection } = props;
    const isSignedIn = walletConnection.isSignedIn();
    const claim = async () => {
        await contract.claim(
            {},
            300000000000000,
            0
        );
    };
  return (
      <div className="wrapper">
          <nav className="header-nav">
              <a href="/">
                  <span className="logo-text">SeatlabNFT</span>
                  <img alt="SeatlabNFT Logo" className="header-logo--large" src={logo} srcSet={`${logo}, ${logo2x} 2x, ${logo3x} 3x`} />
                  <img alt="SeatlabNFT Logo" className="header-logo--small" src={logo} srcSet={`${logoSmall}, ${logoSmall2x} 2x, ${logoSmall3x} 3x`} />
              </a>
              {isSignedIn &&
                  <button className="logged-in" onClick={logout}>{accountId}</button>
              }
              {!isSignedIn &&
                  <button onClick={login}>Log in with NEAR</button>
              }
          </nav>
          <main>
              <section>
                  {isSignedIn &&
                      <>
                          <h2>Hello <span className="blue-text hide-on-large">{getFormattedAccountId(accountId).small}</span><span className="blue-text show-on-large">{getFormattedAccountId(accountId).large}</span>!</h2>
                          <h2>You have {claimableTokens} $SEAT to claim</h2>
                          {claimableTokens > 0 &&
                              <button onClick={claim}>Claim $SEAT</button>
                          }
                          {claimableTokens <= 0 &&
                              <a className="button" href={nearConfig.walletUrl}>View in Near Wallet</a>
                          }
                      </>
                  }
                  {!isSignedIn &&
                      <>
                          <h2>Welcome to the SeatlabNFT investor portal</h2>
                          <h3>Please log in to continue</h3>
                          <button onClick={login}>Log in with NEAR</button>
                      </>
                  }
              </section>
          </main>
          <footer>
              <nav>
                  <a className="footer-logo" href="/">
                      <span className="logo-text">SeatlabNFT</span>
                      <img alt="SeatlabNFT logo" src={logo} srcSet={`${logo}, ${logo2x} 2x, ${logo3x} 3x`} />
                  </a>
                  <ul className="social-links">
                      <li className="social-links__link">
                          <a href="https://twitter.com/seatlabnft" target="_blank" rel="noreferrer noopener"><TwitterLogo /></a>
                      </li>
                      <li className="social-links__link">
                          <a href="https://discord.gg/kTpaEwACHQ" target="_blank" rel="noreferrer noopener"><DiscordLogo /></a>
                      </li>
                      <li className="social-links__link">
                          <a href="https://seatlabnft.medium.com/" target="_blank" rel="noreferrer noopener"><MediumLogo /></a>
                      </li>
                  </ul>
              </nav>
          </footer>
      </div>
  );
};

export default App;
